<script>

import Languages from "../../lang/lang";

export default {
  name: "User",
  props: ['user'],
  computed: {
    lang() {
      return Languages.texts('user');
    }
  }
}
</script>

<template>
  <div class="user-info">
    <div class="user-name">{{ user.name }} {{ user.lastName }}</div>
    <router-link to="/account" class="link-button white">
      {{ lang['settings'] }}
    </router-link>
  </div>
</template>